/**
 * SCA EXEMPTION FLOW
 */
export const SCA_EXEMPTION_TO_BE_VALIDATED = 'SCA_EXEMPTION_TO_BE_VALIDATED'

/**
 * NON-SCA EXEMPTION FLOW
 */
export const START = 'START'
export const SCA_REQUIRED = 'SCA_REQUIRED'
export const ACCOUNT_SELECTION_REQUIRED = 'ACCOUNT_SELECTION_REQUIRED'

/**
 * CANCELATION FLOW
 */
export const CANCELLATION_SCA_REQUIRED = 'CANCELLATION_SCA_REQUIRED'
export const PAYMENT_CANCELED = 'PAYMENT_CANCELED'

/**
 * FINAL STATE
 */
export const VALIDATION_SUCCESS = 'VALIDATION_SUCCESS'
export const VALIDATION_FAILURE = 'VALIDATION_FAILURE'
export const PAYMENT_EXPIRED = 'PAYMENT_EXPIRED'